import { render, staticRenderFns } from "./TypoNTCConfig.vue?vue&type=template&id=3e051f5c&scoped=true&"
import script from "./TypoNTCConfig.vue?vue&type=script&lang=js&"
export * from "./TypoNTCConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e051f5c",
  null
  
)

export default component.exports